import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties, IPropertiesWithValues } from '../../forms/builder/types'
import styled from 'styled-components'
import RichTextEditor from 'react-rte'
import { Formik, Form } from 'formik'
import { FillingCheckBoxes } from '../../forms/filling/components/controls/FillingCheckBoxes'
import { FillingDropdown } from '../../forms/filling/components/controls/FillingDropdown'
import { FillingHeading } from '../../forms/filling/components/controls/FillingHeading'
import { FillingLabel } from '../../forms/filling/components/controls/FillingLabel'
import { FillingLineBreak } from '../../forms/filling/components/controls/FillingLineBreak'
import { FillingParagraph } from '../../forms/filling/components/controls/FillingParagraph'
import { FillingRangeCtrl } from '../../forms/filling/components/controls/FillingRangeCtrl'
import { FillingRating } from '../../forms/filling/components/controls/FillingRating'
import TextEditorEmbed from '../../forms/filling/components/TextEditorEmbed'
import { InputFake, InputFakeViewer } from '../../../components/TextInput'

interface IFilledFormViewerProps {
  formName: string,
  formDescription?: string,
  updatedAt: string,
  updatedBy: string,
  values?: string
}
const EditorWrapper = styled(Flex)`
overflow-y:auto;
width: 100%;
 max-width: 836px;
padding-right: 24px;
max-height: 100%;
padding-bottom: 24px;
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`
const getInitialData = (tree: Array<IPropertiesWithValues>) => {
  console.log({ tree });
  const data: any = {};

  for (let index = 0; index < tree.length; index++) {
    const element = tree[index];
    if (element.key === 'LineBreak' || element.key === 'Header' || element.key === 'Label' || element.key === 'Paragraph') continue;

    if (element.key === 'TextInput' || element.key === 'Email' || element.key === 'Date') {
      data[element.id] = element.value
      continue;
    }
    if (element.key === 'Range') {
      data[element.id] = element.value
      continue;
    }
    if (element.key === 'Dropdown') {
      data[element.id] = element.value;
      continue;
    }
    if (element.key === 'Rating') {
      data[element.id] = element.value
      continue;
    }
    if (element.key === 'NumberInput') {
      data[element.id] = element.value
      continue;
    }
    if (element.key === 'TextArea') {
      data[element.id] = RichTextEditor.createValueFromString(element.value?.toString() || '', 'html')
      continue;
    }

    if (element.key === 'Checkboxes') {
      for (let i2 = 0; i2 < (((element.params || {}).ctrlProps || {}).options || []).length; i2++) {
        const e2 = (((element.params || {}).ctrlProps || {}).options || [])[i2];
        if (!element.values) {
          data[`${element.id}__${e2.value}`] = false
          continue
        }
        console.log({
          e2,
          v: element.values
        })
        for (let i2 = 0; i2 < element.values.length; i2++) {
          const val = element.values[i2];
          if (val[`chk1`] === true) {
            console.log('chk1 TRUE')
          } else {
            console.log('chk1 FALSE', val[`chk1`])
          }
          if (val[`${e2.value}`] && val[`${e2.value}`] === true) {
            data[`${element.id}__${e2.value}`] = true
          } else if (val[`${e2.value}`] !== undefined) {
            data[`${element.id}__${e2.value}`] = false
          }
        }
        // data[`${element.id}__${e2.value}`] = (element.values || {})[`${element.id}__${e2.value}`] || false;
      }
    }
  }

  console.log({ data });
  return data;
};
interface IFillingInputProps {
  properties: IPropertiesWithValues,
  name: string,

}

const ReplacementInput: React.FC<IFillingInputProps> = ({ properties, name }, props) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <InputFakeViewer name={name} {...((properties || {}).params || {}).ctrlProps} {...props} style={{
        height: 'fit-content',
        flexWrap: 'wrap',
        overflow: 'hidden',
        maxWidth: '100%',
        display: 'block'
      }}
        value={properties.value || ''} />
    </Flex>);
}

const ReplacementTextArea: React.FC<IFillingInputProps> = ({ properties, name }, props) => {
  console.log('RT', {
    properties,
    name
  })
  const html = (properties.value || '').toString()//.replace(/<\/p>/g, '</p>\n').replace(/\n/g,"<br />")
  console.log({ html })
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <InputFakeViewer style={{
        height: 'fit-content',
        flexWrap: 'wrap',
        overflow: 'hidden',
        maxWidth: '100%',
        display: 'block'
      }}
        dangerouslySetInnerHTML={{ __html: html }}
        name={name} {...((properties || {}).params || {}).ctrlProps} {...props}

      />
    </Flex>);
}

export const FilledFormViewer: React.FC<IFilledFormViewerProps> = ({
  formName,
  formDescription,
  updatedAt,
  updatedBy,
  values,
}) => {
  const [tree, setTree] = useState<IPropertiesWithValues[]>(JSON.parse(values || '[]'))
  useEffect(() => {
    setTree(JSON.parse(values || '[]'))
  }, [])
  useEffect(() => {
    setTree(JSON.parse(values || '[]'))
  }, [values])
  return (
    <EditorWrapper width={'100%'} flexDirection={'column'}>
      <Formik
        initialValues={{ ...getInitialData(tree) }}
        enableReinitialize
        onSubmit={(values, actions) => {
        }}
      >
        {({ touched, errors, isValid, values, submitForm, setFieldValue, setFieldTouched }) => {
          // console.log({ errors, touched, values });
          return (
            <Form>
              <>
                {tree.map((treeItem) => (
                  <Flex
                    width={'100%'}
                    style={{
                      padding: treeItem.key === 'Header' ? '12px 0 20px 0' : treeItem.key === 'Label' ? '18px 0 12px' : treeItem.key === 'LineBreak' ? '6px 0' : '6px 0 12px 32px',
                    }}
                  >
                    {treeItem.key === 'TextInput' || treeItem.key === 'NumberInput' || treeItem.key === 'Email' || treeItem.key === 'Date' ? (
                      <ReplacementInput properties={treeItem} name={treeItem.id} />
                    ) : null}
                    {treeItem.key === 'LineBreak' ? <FillingLineBreak /> : null}
                    {treeItem.key === 'Checkboxes' ? <FillingCheckBoxes
                      disabled properties={treeItem} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} /> : null}
                    {treeItem.key === 'Header' ? <FillingHeading properties={treeItem} /> : null}
                    {treeItem.key === 'Range' ? <FillingRangeCtrl disabled name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                    {treeItem.key === 'TextArea' ? <ReplacementTextArea name={treeItem.id} properties={treeItem} /> : null}
                    {treeItem.key === 'Dropdown' ? (
                      <FillingDropdown
                        name={treeItem.id}
                        values={values}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        disabled
                        properties={{
                          ...treeItem,
                        }}
                        touched={touched}
                        errors={errors}
                      />
                    ) : null}
                    {treeItem.key === 'Label' ? <FillingLabel properties={treeItem} /> : null}
                    {treeItem.key === 'Rating' ? <FillingRating disabled name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                    {treeItem.key === 'Paragraph' ? <FillingParagraph properties={treeItem} /> : null}
                  </Flex>
                ))}
              </>
            </Form>
          );
        }}
      </Formik>
    </EditorWrapper>);
}